import { Component, Input, OnInit, ViewChild, ChangeDetectorRef, TemplateRef, ViewContainerRef, HostListener } from '@angular/core';
import { Router } from "@angular/router";
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';
import { Observable, combineLatest } from 'rxjs';
import { JobService } from 'src/app/services/jobs/job.service';
import { StaffService } from 'src/app/services/staff/staff.service';
import { MatDialog, MatMenuTrigger } from '@angular/material';
import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import { Subscription } from 'rxjs';
import { ClientService } from '../../services/client.service';
import { months } from '../../_models/staticArray';
import { TimeSheetService } from '../../services/time-sheet.service';
import { LabourJobService } from '../../labour-job/labour-job.service';
import { getBindingElementVariableDeclaration } from 'tslint';
const moment = extendMoment(Moment);

@Component({
  selector: 'app-new-schedular',
  templateUrl: './new-schedular.component.html',
  styleUrls: ['./new-schedular.component.scss']
})
export class NewSchedularComponent implements OnInit {
  months = months
  data = [];
  learner = [];
  dates = [];
  location = [];
  jobs: any;
  staff: any;
  today
  weeknumber;
  nextWeek: number;
  previousWeek: number;
  newInstructureArray = []
  finalArray = []
  displayFinalArray = []
  users: any;
  loading: boolean = false;
  first;
  last;
  selectedStaff = [];
  staffCopy: any;
  usersCopy: any;
  allWeeks: any[];
  selectedWeek
  loadingMenu: boolean;
  sub: Subscription;
  tempWeekNumber: any;
  user: any;
  clients: any;
  clientsCopy: any;
  selectedClient: any;
  isDisable = true
  afterFilter = {
    title: "No Users Found!",
    data: "Sorry, no member matched your search"
  }
  yearList = []
  selectedYear
  currentYear

  constructor(
    public _clientService: ClientService,
    private _jobService: JobService,
    public _staffService: StaffService,
    public router: Router,
    public dialog: MatDialog,
    public overlay: Overlay,
    public viewContainerRef: ViewContainerRef,
    public timeSheetService: TimeSheetService,
    public _labourjobService: LabourJobService,
    private _timeSheetService: TimeSheetService,
  ) {
    // this.user = JSON.parse(localStorage.getItem('userRoles'))
  }
  @Input() contextMenu: ContextMenuComponent;

  // @ViewChild(ContextMenuComponent, { static: true }) public loaderMenu: ContextMenuComponent;
  @ViewChild('userMenu', { static: false }) userMenu: TemplateRef<any>;
  overlayRef: OverlayRef | null;

  @ViewChild(MatMenuTrigger, { static: false }) public loaderMenu: MatMenuTrigger;
  @ViewChild(ContextMenuComponent, { static: true }) public basicMenu: ContextMenuComponent;
  public contextMenuActions = [
  ];
  menuArray = []

  async ngOnInit() {
    await this._timeSheetService.getYearList().then((yearData: { currentYear: Number, yearList: [], systemDate: '' }) => {
      console.log("CURRENT DATE IN SERVICE", yearData)
      this.yearList = yearData.yearList
      this.currentYear = yearData.currentYear
      this.selectedYear = this.currentYear
      this.today = new Date(yearData.systemDate)
      this.getStaffDiaryData()
      this.showWeeks()
      // this.systemDate = yearData.systemDate
      // this.getCurrentMonthWeeks()
    })
  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler(event) {
    console.debug("Scroll Event");
    let topPosition = $(".scheduler_row").scrollTop();
    $(".scheduler_row .user-name").css({ "top": (topPosition) });
  }

  // UTILITY

  getWeekDates(i) {
    console.log("what is the next week data", i);
    this.first = null
    this.last = null
    let dates = []
    let week = i
    return new Promise((resolve, reject) => {
      let j
      for (j = 0; j <= 1; j++) {
        let weekStartDate = moment().year(this.selectedYear).startOf('isoWeek').isoWeek(week)
        console.log("weekStartDate", weekStartDate, week);

        let weekEndDate = moment().year(this.selectedYear).endOf('isoWeek').isoWeek(week)
        dates.push({ date: weekStartDate.format('DD/MM/YYYY'), day: moment(weekStartDate).format('dddd') })
        while (weekStartDate.add(1, 'days').diff(weekEndDate) <= 0) {
          dates.push({ date: weekStartDate.clone().format('DD/MM/YYYY'), day: moment(weekStartDate).format('dddd') });
        }
        this.dates = dates
        this.first = this.dates[0].date
        this.last = this.dates[this.dates.length - 1].date
        ++week
        j++
      }
      console.log("Here the date array to be send", dates);

      resolve(dates)
    }).then((resolvedArray) => {
      console.log("what is resolve array", resolvedArray);
    })
  }

  next() {
    console.log("Next week number", this.nextWeek, this.tempWeekNumber, this.nextWeek);
    console.log("Call this or not", this.selectedWeek);
    console.log("ALL WEEKS DATA", this.allWeeks)
    this.loading = true
    this.nextWeek = this.tempWeekNumber ? this.tempWeekNumber + 1 : this.nextWeek + 1
    this.previousWeek = this.nextWeek
    this.weeknumber = this.nextWeek
    const tempWeek = this.allWeeks.find((x) => x.weekNumber === this.nextWeek)
    if (tempWeek !== undefined) this.selectedWeek = tempWeek
    console.log("what is the next week data", this.nextWeek, this.previousWeek, this.tempWeekNumber);
    this.getWeekDates(this.nextWeek).then((dateList) => {
      console.log("This is the date list after get", dateList);
      console.log("Here the array of date to send", this.dates);
      // this.getSchedularDataofLabourjob()
      this.getBothSchedularData()
    })
  }

  previous() {
    console.log("Call this or not", this.selectedWeek);
    console.log("ALL WEEKS DATA", this.allWeeks)
    this.loading = true
    this.previousWeek = this.tempWeekNumber ? this.tempWeekNumber - 1 : this.previousWeek - 1;
    console.log("here the previous week data", this.previousWeek);
    this.weeknumber = this.previousWeek
    this.nextWeek = this.previousWeek
    const tempWeek = this.allWeeks.find((x) => x.weekNumber === this.previousWeek)
    if (tempWeek !== undefined) this.selectedWeek = tempWeek
    this.getWeekDates(this.previousWeek).then((dateList) => {
      console.log("This is the date list after get", dateList);
      console.log("Here the array of date to send", this.dates);
      // this.getSchedularDataofLabourjob()
      this.getBothSchedularData()
    })
  }

  oldView() {
    this.router.navigateByUrl('scheduler/view')
  }

  //Evenet when select user or week from drop-down

  selectChanges(event) {
    console.log("THIS IS THE SELECTED WEEK DATA", this.selectedWeek)
    if (this.selectedWeek !== undefined) this.weeknumber = this.selectedWeek.weekNumber
    if (this.selectedStaff && this.selectedStaff.length || this.selectedWeek != null) this.isDisable = false
    else this.isDisable = true
  }
  changeYear(event) {
    console.log("EVENT TO BE CHANGE", event, this.selectedYear)
    this.selectedWeek = null
    this.isDisable = true
    this.showWeeks()
  }


  getFilteredData() {
    this.loading = true
    console.log("selectedStaff", this.selectedStaff, "selectedWeek", this.selectedWeek, "selected client", this.selectedClient, this.weeknumber)
    let tempUser = [];
    if (this.selectedStaff && this.selectedStaff.length) {
      this.staff = this.selectedStaff;
      this.selectedStaff.forEach(single => {
        let temp = this.usersCopy.filter(function (o) {
          return o.staffId == single._id
        })
        console.log("temp")
        tempUser.push(...temp)
        console.log('tempUser', tempUser)
        this.users = tempUser
        console.log("this.staff", this.staff)
        console.log("this.users", this.users)
      })
    } else {
      this.staff = this.staffCopy
      this.users = this.usersCopy
    }

    if (this.selectedWeek != undefined) {
      this.tempWeekNumber = this.selectedWeek.weekNumber
      this.getWeekDates(this.weeknumber)
    } else {
      console.log("what is week number", this.weeknumber);
      this.tempWeekNumber = null
      this.getWeekDates(this.weeknumber)
    }

    if (this.selectedClient && this.selectedClient.length) {
      //console.log('this.selectedClient', this.selectedClient)  
      console.log('this.users', this.usersCopy)
      this.selectedClient.forEach(single => {
        let temp = this.usersCopy.filter(function (o) {
          let dateArray = []
          // console.log("o =====", o)
          if (o.dates.length) {
            o.dates.forEach(date => {
              date.clients.some(item => {
                // console.log('item.client._id', item.client._id)
                if (item.client._id == single._id) {
                  dateArray.push(item)
                }
              })
            })
            if (dateArray && dateArray.length) {
              tempUser.push(o)
            }
          }
        })
        console.log("temp filter for clients is ==========>>>>>>>>>>", temp)
        // tempUser.push(...temp)
        console.log('tempUser when client select', tempUser)
        this.users = tempUser
      })
    }


    if (!this.selectedClient && !this.selectedWeek && !this.selectedStaff) {
      this.staff = this.staffCopy
      this.users = this.usersCopy
    }
    //else {
    //  this.staff = this.staffCopy
    //  this.users = this.usersCopy
    //}
    this.users = this.users.filter((item, pos) => {
      return this.users.indexOf(item) == pos;
    })
    setTimeout(() => {
      this.loading = false
    }, 1000)
  }
  showWeeks() {
    // this.step = i;
    this.allWeeks = [];
    this.months.forEach(item => {
      let month = item.id
      return new Promise((resolve, reject) => {
        let year = this.selectedYear
        let startDate = moment.utc([year, month])
        let monthStart = moment(startDate).startOf('month')
        let monthEnd = moment(startDate).endOf('month')
        let totalWeeks = moment(this.selectedYear).weeksInYear()

        let monthStartWeekNumber = moment(monthStart).isoWeek()
        let monthEndWeekNumber = moment(monthEnd).isoWeek()
        if (monthEndWeekNumber == 1) monthEndWeekNumber = 52
        if (monthStartWeekNumber == totalWeeks) monthStartWeekNumber = 0
        // if (monthStartWeekNumber == 53) monthStartWeekNumber = 1

        console.log("monthStartWeekNumber", monthStartWeekNumber, "monthEndWeekNumber", monthEndWeekNumber);
        for (let i = monthStartWeekNumber; i <= monthEndWeekNumber; i++) {
          let weekStartDate = moment().year(this.selectedYear).startOf('isoWeek').isoWeek(i);
          if (i == 1 && weekStartDate < moment().year(this.selectedYear).startOf('year')) weekStartDate = moment().year(this.selectedYear).startOf('year');
          // let weekEndDate = moment('2020').startOf('week').day('Saturday').week(i);
          let weekEndDate = moment().year(this.selectedYear).endOf('isoWeek').isoWeek(i);
          // console.log("weekEndDate", weekEndDate.date(), weekEndDate.month());
          if (weekEndDate > moment().year(this.selectedYear).endOf('year')) {
            // console.log("weekEndDate > moment().endOf('year')", weekEndDate, moment().endOf('year'));
            weekEndDate = moment().year(this.selectedYear).endOf('year')
          }
          const tempIndex = this.allWeeks.findIndex((x) => x.weekNumber === i)
          console.log("TEMP INDEX OF MONTH", tempIndex)
          if (tempIndex == -1) {
            this.allWeeks.push({
              weekNumber: i, weekStartDate: weekStartDate, weekEndDate: weekEndDate,
              label: "Week-" + i + '  From-' + moment(weekStartDate).format('DD/MM/YYYY') + ' ' + 'To-' + moment(weekEndDate).format('DD/MM/YYYY')
            })
          }
          // console.log("weekNumber: i", i, "weekStartDate", weekStartDate, "weekEndDate", weekEndDate);
        }
        // this.show = true;
        resolve(this.allWeeks)
      }).then((resolvedAllWeeks) => {
        // console.log("---resolvedAllWeeks-- in AFTER FOR LOOP", resolvedAllWeeks);
      })
    })
    console.log("$$allWeeks", this.allWeeks);
    // this.index = i;
  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '1000px', height: '967px' });
    return dialogRef.afterClosed();
  }

  // API CALL

  getStaffDiaryData() {
    this.loading = true
    // this.timeSheetService.getSystemDate().subscribe((date) => {
    // console.log("Sysytem date get", date);
    // this.today = new Date(date.systemDate)

    this.weeknumber = moment(this.today, "DDMMYYYY").isoWeek();
    console.log("this.today", this.today, this.weeknumber);
    this.nextWeek = this.weeknumber;
    this.previousWeek = this.weeknumber;
    console.log("What is week number value", this.weeknumber, this.nextWeek, this.previousWeek);

    this.getWeekDates(this.weeknumber).then((dateList) => {
      console.log("This is the date list after get", dateList);
      console.log("Here the array of date to send", this.dates);
      // this.getSchedularData()
      this.getBothSchedularData()
      // this.getSchedularDataofLabourjob()
    })
    // })
  }

  getBothSchedularData() {
    return new Promise((resolve, reject) => {
      this.loading = true
      let obj = {
        dates: this.dates,
      }
      combineLatest([
        this._jobService.getSchedularData(obj),
        this._labourjobService.getPlannerData(obj)
      ]).subscribe((data: any) => {
        // this._jobService.getSchedularData(obj).subscribe((data: any) => {
        console.log("data=========== after new structure", data);
        this.staff = data[1].instructors;
        this.staffCopy = data[1].instructors
        this.jobs = data[1].client
        this.users = this.mergeUserDates(data[0].user, data[1].user)
        this.usersCopy = this.users;
        console.log("this.users", this.users);
        // this.users = data.user
        // this.usersCopy = data.user
        // this.clients = data.clientList
        // this.clientsCopy = data.clientList
        this.getFilteredData()
        resolve(data)
      }, err => {
        console.log("error while get data", err);
        reject(err)
      })
    })
  }

  mergeUserDates(mpDates, labourDates) {
    labourDates.forEach(date => {
      // if (date.role.includes("mp")) {
      console.log("labourDates.date: ", date);
      let temp = mpDates.find((x) => x.staffId == date.staffId)
      if (temp) {
        date.dates = temp.dates.concat(date.dates)
      }
      // }
    });

    return labourDates
  }

  getSchedularData() {
    return new Promise((resolve, reject) => {

      this.loading = true
      let obj = {
        dates: this.dates,
      }
      this._jobService.getSchedularData(obj).subscribe((data: any) => {
        console.log("data=========== after new structure", data);
        this.staff = data.instructors;
        this.staffCopy = data.instructors
        this.users = data.user
        this.usersCopy = data.user
        // this.jobs = data.client
        // this.clients = data.clientList
        // this.clientsCopy = data.clientList
        this.getFilteredData()
        resolve(data)
      }, err => {
        console.log("error while get data", err);
        reject(err)
      })
    })
  }


  getSchedularDataofLabourjob() {
    return new Promise((resolve, reject) => {
      let obj = {
        dates: this.dates
      }

      this._labourjobService.getPlannerData(obj).subscribe((data: any) => {
        console.log("DATA OF LABOUR JOBS STAFF USERS", data);
        this.staff = data.instructors;
        this.staffCopy = data.instructors
        this.users = data.user
        this.usersCopy = data.user
        this.jobs = data.jobs
        this.getFilteredData()
        resolve(data)
      })

    })
  }
}
